import type { FunctionComponent, PropsWithChildren } from 'react';

import type { FeatureFlagService, FeatureName } from '~/shared/feature-flag-service/feature-flag-service';

export type PageWithFeatureFlagEnabledProperties = {
    readonly enabledFeatureName: FeatureName;
    readonly featureFlagService: FeatureFlagService;
};

export const PageWithFeatureFlagEnabled: FunctionComponent<PropsWithChildren<PageWithFeatureFlagEnabledProperties>> = (
    properties,
) => {
    const { children, enabledFeatureName, featureFlagService } = properties;

    if (featureFlagService.isFeatureFlagEnabled(enabledFeatureName)) {
        return children;
    }

    return null;
};
